module.exports = __webpack_public_path__ + "static/media/[Keats_and_Beats]2010-11-06.6f634bb2.md";